import React from "react";
import { Box, Typography } from "@mui/material";
import UiFormControlSelection from "../../common/ui/UiFormControlSelection";
import UiFormField from "../../common/ui/UiFormField";

export default function PaymentMethodForm() {
  return (
    <>
      <UiFormField
        fastField={false}
        type="text"
        label={"Bank Name (Required)"}
        showFloatingLabel={true}
        fieldName="name"
      />
      <UiFormField
        fastField={false}
        type="text"
        label={"Routing Number (Required)"}
        showFloatingLabel={true}
        fieldName="routing_number"
      />
      <UiFormField
        fastField={false}
        type="text"
        label={"Account Number (Required)"}
        showFloatingLabel={true}
        fieldName="account_number"
      />
      <Box mb={1}>
        <Typography>Account Type</Typography>
      </Box>
      <UiFormControlSelection
        type="radio"
        label="Account Type"
        fieldName="account_type"
        radioOptionsData={[
          {
            label: "Checking",
            value: "Checking",
          },
          {
            label: "Savings",
            value: "Savings",
          },
        ]}
      />
    </>
  );
}
